import React, {Component} from 'react';

import Core from './../../Core/Core';

export default class ScrollTo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: props.history.location.pathname
    }
  }

  componentDidMount() {

    // Attempt a timeout due to the page likely to still be loading
    setTimeout(() => this.jump(), 500);
    this.props.history.listen((location, action) => {
      if (this.state.path !== location.pathname || action === 'REPLACE') {
        this.setState({path: location.pathname});
        this.jump();
      }
    });
  }

  shouldComponentUpdate() {
    return false;
  }

  jump() {
    if (this.wrapped && this.props.history.location.pathname.search(this.props.path) !== -1) {
      Core.utils.goToElement(this.wrapped.offsetTop - Core.header.getHeight() - Core.header.getSubHeaderHeight());
    }
  }

  render() {
    return <div ref={ref => this.wrapped = ref}>{this.props.children}</div>;
  }
}

export function toScrollTo(Child, path) {
  return class ScrollToWrapper extends Component {
    render() {
      return <ScrollTo path={path} {...this.props}>
        <Child/>
      </ScrollTo>;
    }
  }
}